import $store from "@/store";

export const routeStack: any[] = [];
let isFirstRoute = true;

export const beforeRouteForPageTransition = function (to, from) {
  const firstRoute = (this as any).history._startLocation;
  // 一加载首次，不用滑动效果
  if (to.path === firstRoute && isFirstRoute) {
    $store.commit("app/setPageTransitionNameMutation", "slide-fade");
    return;
  }
  isFirstRoute = false;
  // console.log(($store.state as any).app.routeBack);
  // 切换动画
  if (($store?.state as any).app.routeBack) {
    $store.commit("app/setPageTransitionNameMutation", "slide-left");
  } else {
    $store.commit("app/setPageTransitionNameMutation", "slide-right");
  }
};

export const updateRouteStack = function (to, from) {
  // 前进
  if (!routeStack.find(o => o.path === to.path)) {
    $store.commit("app/setRouteBackMutation");
    routeStack.push(to);
  }
  // 返回
  else if (
    routeStack.length &&
    routeStack[routeStack.length - 1].path === from.path
  ) {
    $store.commit("app/setRouteBackMutation", true);
    routeStack.pop();
  }
};
